import React from 'react';

type Variant = 'about' | 'how-it-works' | 'faq' | 'play';

interface BentoIllustrationProps {
  variant?: Variant;
  idSuffix: string;
}

/** Hue rotation (deg) for bento illustrations – teal/cyan, distinct from topic colours. */
const BENTO_HUE_ROTATE = 150;

/**
 * Bento illustration – gradient background with noise effect.
 * Reusable for About page bento blocks. Each instance needs unique idSuffix for filter IDs.
 */
const BentoIllustration: React.FC<BentoIllustrationProps> = ({ idSuffix }) => {
  const grad3Id = `bento-grad-3-${idSuffix}`;

  return (
    <div
      className="bento-illustration"
      aria-hidden
      style={{ '--bento-hue-rotate': `${BENTO_HUE_ROTATE}deg` } as React.CSSProperties}
    >
      <svg
        className="bento-illustration__svg"
        viewBox="0 0 400 200"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id={grad3Id} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="var(--color-brand-3)" />
            <stop offset="100%" stopColor="var(--color-brand-4)" />
          </radialGradient>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${grad3Id})`} />
      </svg>
    </div>
  );
};

export default BentoIllustration;
